import React, { useState, useEffect } from "react";
import { Container } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { FaArrowLeft, FaArrowUp, FaDownload } from "react-icons/fa";
import AOS from "aos";
import "aos/dist/aos.css";
import NavbarMenu from "../heroSection/NavbarMenu";
import Footer from "../footer/Footer";
import "./DriverTerms.css";
import SEO from "../SEO";

export default function DriverTerms() {
  const { t } = useTranslation();
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    AOS.init({ once: true, duration: 1000, offset: 120 });
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 400);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const sections = [
    {
      number: "1",
      title: t("driverTerms.s1.title"),
      content: (
        <>
          <p>{t("driverTerms.s1.p1")}</p>
          <p>{t("driverTerms.s1.p2")}</p>
          <p>{t("driverTerms.s1.p3")}</p>
        </>
      ),
    },
    {
      number: "2",
      title: t("driverTerms.s2.title"),
      content: (
        <>
          <p>{t("driverTerms.s2.p1")}</p>
          <p>{t("driverTerms.s2.p2")}</p>
          <p>{t("driverTerms.s2.p3")}</p>
          <ul>
            <li>{t("driverTerms.s2.l1")}</li>
            <li>{t("driverTerms.s2.l2")}</li>
            <li>{t("driverTerms.s2.l3")}</li>
            <li>{t("driverTerms.s2.l4")}</li>
          </ul>
        </>
      ),
    },
    {
      number: "3",
      title: t("driverTerms.s3.title"),
      content: (
        <>
          <p>{t("driverTerms.s3.intro")}</p>
          <ul>
            <li>{t("driverTerms.s3.l1")}</li>
            <li>{t("driverTerms.s3.l2")}</li>
            <li>{t("driverTerms.s3.l3")}</li>
          </ul>
          <p>{t("driverTerms.s3.p2")}</p>
        </>
      ),
    },
    {
      number: "4",
      title: t("driverTerms.s4.title"),
      content: (
        <>
          <p>{t("driverTerms.s4.p1")}</p>
          <p>{t("driverTerms.s4.p2")}</p>
        </>
      ),
    },
    {
      number: "5",
      title: t("driverTerms.s5.title"),
      content: (
        <>
          <p>{t("driverTerms.s5.intro")}</p>
          <ul>
            <li>{t("driverTerms.s5.l1")}</li>
            <li>{t("driverTerms.s5.l2")}</li>
            <li>{t("driverTerms.s5.l3")}</li>
            <li>{t("driverTerms.s5.l4")}</li>
          </ul>
        </>
      ),
    },
    {
      number: "6",
      title: t("driverTerms.s6.title"),
      content: (
        <>
          <p>{t("driverTerms.s6.p1")}</p>
          <p>{t("driverTerms.s6.p2")}</p>
        </>
      ),
    },
    {
      number: "7",
      title: t("driverTerms.s7.title"),
      content: (
        <>
          <p>{t("driverTerms.s7.p1")}</p>
          <p>{t("driverTerms.s7.p2")}</p>
          <ul>
            <li>{t("driverTerms.s7.l1")}</li>
            <li>{t("driverTerms.s7.l2")}</li>
            <li>{t("driverTerms.s7.l3")}</li>
            <li>{t("driverTerms.s7.l4")}</li>
            <li>{t("driverTerms.s7.l5")}</li>
          </ul>
        </>
      ),
    },
    {
      number: "8",
      title: t("driverTerms.s8.title"),
      content: (
        <>
          <p>{t("driverTerms.s8.p1")}</p>
          <p>{t("driverTerms.s8.p2")}</p>
          <ul>
            <li>{t("driverTerms.s8.l1")}</li>
            <li>{t("driverTerms.s8.l2")}</li>
            <li>{t("driverTerms.s8.l3")}</li>
          </ul>
          <p>{t("driverTerms.s8.p3")}</p>
          <p className="terms-warning">{t("driverTerms.s8.penalty")}</p>
          <p>{t("driverTerms.s8.damages")}</p>
        </>
      ),
    },
    {
      number: "9",
      title: t("driverTerms.s9.title"),
      content: (
        <>
          <p>{t("driverTerms.s9.p1")}</p>
          <p>{t("driverTerms.s9.p2")}</p>
          <p>{t("driverTerms.s9.p3")}</p>
        </>
      ),
    },
    {
      number: "10",
      title: t("driverTerms.s10.title"),
      content: (
        <>
          <p>{t("driverTerms.s10.p1")}</p>
          <ul>
            <li>{t("driverTerms.s10.l1")}</li>
            <li>{t("driverTerms.s10.l2")}</li>
            <li>{t("driverTerms.s10.l3")}</li>
          </ul>
        </>
      ),
    },
    {
      number: "11",
      title: t("driverTerms.s11.title"),
      content: (
        <>
          <p>{t("driverTerms.s11.p1")}</p>
          <p>{t("driverTerms.s11.p2")}</p>
          <p>{t("driverTerms.s11.p3")}</p>
        </>
      ),
    },
    {
      number: "12",
      title: t("driverTerms.s12.title"),
      content: <p>{t("driverTerms.s12.p1")}</p>,
    },
    {
      number: "13",
      title: t("driverTerms.s13.title"),
      content: (
        <>
          <p>{t("driverTerms.s13.p1")}</p>
          <p>{t("driverTerms.s13.p2")}</p>
          <p>{t("driverTerms.s13.p3")}</p>
        </>
      ),
    },
    {
      number: "14",
      title: t("driverTerms.s14.title"),
      content: (
        <>
          <p>{t("driverTerms.s14.p1")}</p>
          <ul>
            <li>{t("driverTerms.s14.l1")}</li>
            <li>{t("driverTerms.s14.l2")}</li>
            <li>{t("driverTerms.s14.l3")}</li>
            <li>{t("driverTerms.s14.l4")}</li>
            <li>{t("driverTerms.s14.l5")}</li>
            <li>{t("driverTerms.s14.l6")}</li>
            <li>{t("driverTerms.s14.l7")}</li>
          </ul>
        </>
      ),
    },
    {
      number: "15",
      title: t("driverTerms.s15.title"),
      content: (
        <>
          <p>{t("driverTerms.s15.p1")}</p>
          <p>{t("driverTerms.s15.p2")}</p>
          <p>{t("driverTerms.s15.p3")}</p>
        </>
      ),
    },
    {
      number: "16",
      title: t("driverTerms.s16.title"),
      content: <p>{t("driverTerms.s16.p1")}</p>,
    },
    {
      number: "17",
      title: t("driverTerms.s17.title"),
      content: (
        <>
          <p>{t("driverTerms.s17.p1")}</p>
          <p>{t("driverTerms.s17.p2")}</p>
        </>
      ),
    },
    {
      number: "18",
      title: t("driverTerms.s18.title"),
      content: (
        <>
          <p>{t("driverTerms.s18.p1")}</p>
          <p>{t("driverTerms.s18.p2")}</p>
        </>
      ),
    },
    {
      number: "19",
      title: t("driverTerms.s19.title"),
      content: (
        <>
          <p>{t("driverTerms.s19.p1")}</p>
          <p>{t("driverTerms.s19.p2")}</p>
        </>
      ),
    },
  ];

  return (
    <>
      <SEO
        title="TransCirox – Allgemeine Geschäftsbedingungen | AGB für Transportpartner"
        description="Allgemeine Geschäftsbedingungen (AGB) der TransCiroX GmbH für Transportpartner und Fahrer."
        keywords="AGB, Allgemeine Geschäftsbedingungen, Transportpartner, Fahrer, TransCiroX"
      />
      <NavbarMenu />

      <section className="driver-terms-page mt-5 px-5">
        <Container>
          <div className="terms-card">
            {/* Header */}
            <div className="terms-header">
              <button className="back-btn" onClick={() => window.history.back()}>
                <FaArrowLeft />
              </button>
              <div>
                <h2>{t("driverTerms.agb")}</h2>
              </div>
            </div>

            {/* Scroll Content */}
            <div className="terms-scroll">
              <div className="document">
                <h1>
                  {t("driverTerms.title")}
                  <br />
                  {t("driverTerms.subtitle")}
                </h1>

                <div className="document-meta d-flex gap-3">
                  <span>{t("driverTerms.validFrom")}: {t("driverTerms.validDate")}</span>
                  <span>|</span>
                  <span>{t("driverTerms.version")}: {t("driverTerms.versionNumber")}</span>
                </div>

                <p>
                  {t("driverTerms.company")}, {t("driverTerms.address")}
                </p>

                <div className="document-meta d-flex gap-3">
                  <span>{t("driverTerms.email")}: <a href="mailto:kontakt@transcirox.com">kontakt@transcirox.com</a></span>
                  <span>|</span>
                  <span>{t("driverTerms.website")}: <a href="https://www.transcirox.com">www.transcirox.com</a></span>
                </div>

                <hr />

                {sections.map((section) => (
                  <div key={section.number} className="document-section">
                    <h3>
                      {section.number}. {section.title}
                    </h3>
                    <div>{section.content}</div>
                    <hr />
                  </div>
                ))}
              </div>

              {/* Footer */}
              <div className="terms-footer">
                <div className="document-meta">
                  <div>Stand: Juli 2025</div>
                  <div>Version: 1.0</div>
                </div>
              </div>
            </div>

          </div>
        </Container>
      </section>

      {/* Back to top button */}
      {showScrollTop && (
        <button
          className="back-to-top"
          onClick={scrollToTop}
          aria-label="Back to top"
        >
          <FaArrowUp />
        </button>
      )}

      <Footer />
    </>
  );
}